export default "__VITE_ASSET__BzBzRe0O__"